import { colors } from 'theme'
import { palette } from 'theme/tokens/palette'

export const defaultThemeStyles = {
    background: colors.white,
    navigation: colors.greyLight,
    selected: palette.info[700],
    border: colors.greyLight,
    currentMonthText: colors.black,
}
